export default __webpack_public_path__ + "static/media/receipts.8e5985ab.svg";